import styled from 'styled-components'

import { getStyles } from '../../utils'

export const Span = styled.span`
    ${getStyles()}
`
